import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Youtube, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  const servicesList = t('footer.servicesList', { returnObjects: true });
  
  return (
    <footer className="bg-dark-bg text-white py-12 px-6 border-t-2 border-burgundy">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-cream-gold to-cream-gold-light bg-clip-text text-transparent">EVOX MEDIA</h3>
            <p className="text-cream-gold-light/70 leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-cream-gold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2 text-cream-gold-light/70">
              {servicesList.map((service, index) => (
                <li key={index}>{service}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-cream-gold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2 text-cream-gold-light/70">
              <li><Link to="/about" className="hover:text-cream-gold transition-colors">{t('footer.aboutUs')}</Link></li>
              <li><a href="mailto:business@evoxmedia.co" className="hover:text-cream-gold transition-colors">{t('footer.contactUs')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-cream-gold mb-4">{t('footer.followUs')}</h4>
            <div className="flex gap-4">
              <div className="w-10 h-10 bg-burgundy/50 rounded-full flex items-center justify-center cursor-default">
                <Youtube className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 bg-burgundy/50 rounded-full flex items-center justify-center cursor-default">
                <Instagram className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 bg-burgundy/50 rounded-full flex items-center justify-center cursor-default">
                <Linkedin className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 bg-burgundy/50 rounded-full flex items-center justify-center cursor-default">
                <Twitter className="w-5 h-5" />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-burgundy pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream-gold-light/60 text-sm">
            © 2026 {t('footer.copyright')}
          </p>
          <div className="flex gap-6 text-sm text-cream-gold-light/60">
            <Link to="/terms" className="hover:text-cream-gold transition-colors">{t('footer.terms')}</Link>
            <span>·</span>
            <Link to="/privacy" className="hover:text-cream-gold transition-colors">{t('footer.privacy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
